// Mirror of src/scss/vars/_responsive.scss → $bp_* variables.
// When adding or changing a breakpoint, update both files.

import gsap from "gsap";

export const BP = {
  mobile:         "(max-width: 767px)",
  mobileLandscape: "(max-width: 767px) and (orientation: landscape)",
  mobilePortrait:  "(max-height: 767px) and (orientation: portrait)",
  tablet:          "(min-width: 768px) and (max-width: 1023px)",
  tabletAndMobile: "(max-width: 1023px)",
  desktop:         "(min-width: 1024px)",
  desktopXs:       "(min-width: 1024px) and (max-width: 1279px)",
  desktopS:        "(min-width: 1280px) and (max-width: 1439px)",
  desktopM:        "(min-width: 1440px) and (max-width: 1599px)",
  desktopL:        "(min-width: 1600px)",
  desktopXl:       "(min-width: 1920px)",
  desktopXxl:      "(min-width: 2560px)",
  portrait:        "screen and (orientation: portrait)",
  landscape:       "screen and (orientation: landscape)",
  retina:          "(min-resolution: 2dppx)",
};

const _makeHelper = (query) => (fn) => {
  const mm = gsap.matchMedia();
  mm.add(query, fn);
  return mm; // caller can store and call .revert() for cleanup
};

export const Breakpoints = Object.fromEntries(
  Object.entries(BP).map(([key, query]) => [key, _makeHelper(query)])
);
